module.exports = __webpack_public_path__ + "assets/5-customer-success-manager.70cf58f0.png";